(function () {
    //'use strict';
    app.controller('datamanagementController', ['DataManagementService', 'storeUploadService', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', function (dataManagementService, storeUploadService, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
            $location.path('/login');
            return
        }
        $scope.showSavebtn = true;
        if ($routeParams.share) {
            $scope.showsharelegend = true;
        }

        if ($routeParams.mode == "team") {
            $scope.activeTab = 2;
        } else {
            $scope.activeTab = 1;
        }
        $scope.SelectedObjectID = 0;
        $scope.checkBoxChecked = false;

        $scope.totalNumberRecords = 0;
        $scope.currentPage = 1;
        $scope.teamCurrentPage = 1;

        $scope.pagingInfo = {
            pageNo: 1,
            itemsPerPage: 1,
            sortBy: 'eSpectraObjectUploadedDate',
            reverse: true
        };

        $scope.teamPagingInfo = {
            pageNo: 1,
            itemsPerPage: 1,
            sortBy: 'eSpectraObjectUploadedDate',
            reverse: true
        };

        $scope.setTab = function (tabNum) {
            $scope.checkBoxChecked = false;
            $('#chkAll').prop('checked', '');
            $('#chkTeamAll').prop('checked', '');
            $('.chk').prop('checked', '');
            $('.chkTeam').prop('checked', '');
            $scope.activeTab = tabNum;
        }
        $scope.isSet = function (tabNum) {
            return $scope.activeTab == tabNum;
        }

        $scope.sort = function (sortBy) {
            if (sortBy === $scope.pagingInfo.sortBy) {
                $scope.pagingInfo.reverse = !$scope.pagingInfo.reverse;
            } else {
                $scope.pagingInfo.sortBy = sortBy;
                $scope.pagingInfo.reverse = false;
            }
        };

        $scope.teamSort = function (sortBy) {
            if (sortBy === $scope.teamPagingInfo.sortBy) {
                $scope.teamPagingInfo.reverse = !$scope.teamPagingInfo.reverse;
            } else {
                $scope.teamPagingInfo.sortBy = sortBy;
                $scope.teamPagingInfo.reverse = false;
            }
        };

        $scope.setPage = function (pageNo) {
            $scope.currentPage = pageNo;
        };

        $scope.teamSetPage = function (pageNo) {
            $scope.teamCurrentPage = pageNo;
        };

        //var hideMessage = function () {

        //    $scope.isError = false;
        //    $scope.isSuccess = false;
        //    $scope.isModalError = false;
        //    $scope.isModalSuccess = false;

        //}

        $scope.isPrimaryAdmin = getLocalValue('userRole').toLowerCase() == "primary administrator" ? true : false;

        $scope.isSysAdmin = getLocalValue('userRole').toLowerCase() == "sadmin" ? true : false;

        $('#referencedArticle').keyup(function () {
            var _this = $(this);
            storeUploadService.validateReferenceArticle(_this, $scope);
        })

        $scope.getData = function () {
            progressBarService.showProgressBar();
            $('#chkAll').prop("checked", '');
            $('#chkTeamAll').prop("checked", '');
            dataManagementService.getFiles().then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;

                    //$timeout(hideMessage, 10000);

                }
                else {
                    $scope.setTab($scope.activeTab);
                    $scope.dataManagementDetails = response.data;

                    //if ($scope.isSysAdmin) {
                    //    $scope.isTeamMember = $scope.isSysAdmin ? true : $scope.dataManagementDetails.isTeamMember;
                    //} else if ($scope.isPrimaryAdmin) {
                    //    $scope.isTeamMember = $scope.isPrimaryAdmin ? true : $scope.dataManagementDetails.isTeamMember;
                    //} else {
                    $scope.isTeamMember = $scope.isPrimaryAdmin ? true : $scope.dataManagementDetails.isTeamMember;
                    //}


                    $scope.totalNumberRecords = $scope.dataManagementDetails.dataManagementFiles.length;
                    $scope.totalNumberTeamRecords = $scope.dataManagementDetails.teamManagementFiles.length;
                }
                $scope.checkBoxChecked = false;
                progressBarService.hideProgressBar();
            });
        };

        $scope.openUploadModel = function () {
            $scope.clear();
            $scope.showSavebtn = true;
            $scope.isEditData = false;
            $scope.validDOI = true;
            $scope.isDisableStep1 = false;
            $scope.isDisableStep2 = true;
            $scope.isDisableStep3 = true;
            $('#fileStatus').text('No file selected.');
            var name = getLocalValue("fullName").split(' ');

            $('#firstName').val(name[0]);
            $('#lastName').val(name[1]);

            $scope.dataManagement.FirstName = name[0];
            $scope.dataManagement.LastName = name[1];


            $('#upload').modal('show');
        }
        $scope.clear = function () {
            $scope.message = '';
            $scope.isError = false;
            $scope.isSuccess = false;

            $scope.modalMessage = '';
            $scope.isModalError = false;
            $scope.isModalSuccess = false;

            $scope.FileSelected = false;
            $scope.files = [];

            $scope.isDisableStep1 = false;
            $scope.isDisableStep2 = true;
            $scope.isDisableStep3 = true;

            $scope.SelectedObjectID = 0;

            $("input[type=file]").val('').clone(true);
            $('.border-red').removeClass('border-red');

            $scope.dataManagementValues();

            $scope.dataManagementUpload.$setPristine();
            $scope.dataManagementUpload.$setUntouched();
        }

        $scope.dataManagementValues = function () {
            $scope.dataManagement = {
                HostMaterial: "",
                ChemicalName: "",
                ReferencedArticle: "",
                Techinque: "",
                FirstName: "",
                LastName: "",
                Description: "",
                eSpectraObjectDOI: "",
                eSpectraObjectCalibration: '',
                TotalAllocatedSize: '',
                UsedSize: '',
                MaximumUploadSize: '',
                CasRegistryNumber: ''
            }
            $scope.dataManagement.FileShare = "private";
            $scope.dataManagement.isPublic = 0;
        }

        $scope.EditData = function (objectData) {
            $scope.clear();
            $scope.isEditData = true;
            $scope.validDOI = true;

            $scope.isDisableStep1 = true;
            $scope.isDisableStep2 = true;
            $scope.isDisableStep3 = false;

            if ($scope.activeTab == 2) {
                $scope.showSavebtn = $scope.isPrimaryAdmin;
            } else {
                $scope.showSavebtn = true;
            }
            $scope.eSpectraObjectID = objectData.eSpectraObjectID;
            $scope.eSpectraObjectDataSetName = objectData.eSpectraObjectDataSetName;
            $scope.dataManagement.HostMaterial = objectData.eSpectraSpecimenHostMaterial;
            $scope.dataManagement.ChemicalName = objectData.eSpectraSpecimenChemicalName;
            $scope.dataManagement.ReferencedArticle = objectData.eSpectraObjectDOI;
            $scope.dataManagement.Techinque = objectData.eSpectraObjectTechnique;
            $scope.dataManagement.Description = objectData.eSpectraObjectComment;
            $scope.dataManagement.FirstName = objectData.firstName;
            $scope.dataManagement.LastName = objectData.lastName;
            $scope.dataManagement.eSpectraObjectCalibration = objectData.eSpectraObjectCalibration;
            $scope.dataManagement.FileShare = objectData.eSpectraObjectShareType.toLowerCase();
            $scope.dataManagement.isPublic = objectData.eSpectraObjectShareType.toLowerCase() == "public" ? 1 : 0;
            $scope.dataManagement.CasRegistryNumber = objectData.eSpectraCasRegistryNum;

            $('#upload').modal('show');
        }

        $scope.getData();

        $scope.onFileShareSelected = function (value) {
            storeUploadService.onFileShareSelected(value);
        };

        $scope.onFileCitedSelected = function (value) {
            var flag = false;
            for (var key in $scope.FileCited) {
                if ($scope.FileCited[key]) {
                    flag = true;
                }
            }

            if (value == 'Y' && $scope.FileCited.Yes == true && $scope.FileCited.No == true) {
                $scope.FileCited.No = false;
            } else if (value == 'N' && $scope.FileCited.Yes == true && $scope.FileCited.No == true) {
                $scope.FileCited.Yes = false;
            }

            if (!flag) {
                $scope.FileCited = undefined;
            }
        };

        $scope.ValidateUploadDataManagement = function () {
            var returnVal = true;
            if (!$scope.isEditData) {
                if ($scope.files.length == 0) {
                    $("#browse").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
            }

            if (angular.element("#chemicalName").val() != '') {
                $("#chemicalName").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#chemicalName").focus();
                }
                $("#chemicalName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#technique").val() != '') {
                $("#technique").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#technique").focus();
                }
                $("#technique").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#firstName").val() != '') {
                $("#firstName").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#firstName").focus();
                }
                $("#firstName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#lastName").val() != '') {
                $("#lastName").siblings("label").find("span").fadeOut();
            }
            else {

                if (returnVal) {
                    $("#lastName").focus();
                }
                $("#lastName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (!returnVal) {
                this.dataManagementUpload.$dirty = true;
                this.dataManagementUpload.chemicalName.$dirty = true;
                this.dataManagementUpload.technique.$dirty = true;
                this.dataManagementUpload.firstName.$dirty = true;
                this.dataManagementUpload.lastName.$dirty = true;
            }
            return returnVal;
        }

        $scope.uploadFile = function () {
            if ($scope.ValidateUploadDataManagement()) {
                progressBarService.showProgressBar();
                var data = new FormData();
                data.append("file", $scope.files[0]);
                data.append("eSpectraSpecimenHostMaterial", $scope.dataManagement.HostMaterial);
                data.append("eSpectraSpecimenChemicalName", $scope.dataManagement.ChemicalName);
                data.append("ReferencedArticle", $scope.dataManagement.ReferencedArticle);
                data.append("eSpectraObjectTechnique", $scope.dataManagement.Techinque);
                data.append("eSpectraObjectDesc", $scope.dataManagement.Description);
                data.append("FirstName", $scope.dataManagement.FirstName);
                data.append("LastName", $scope.dataManagement.LastName);
                data.append("eSpectraObjectDOI", $scope.dataManagement.eSpectraObjectDOI);
                data.append("eSpectraObjectCalibration", $scope.dataManagement.eSpectraObjectCalibration);
                data.append("eSpectraObjectShareType", $scope.dataManagement.FileShare);
                data.append("eSpectraCasRegistryNum", $scope.dataManagement.CasRegistryNumber);

                dataManagementService.uploadFile(data).then(function (response) {

                    if (response != null && response.data.message != undefined) {
                        $scope.modalMessage = response.data.message;
                        $scope.isModalError = true;
                        $scope.isModalSuccess = false;
                        progressBarService.hideProgressBar();
                        //$timeout(hideMessage, 10000);
                    }
                    else {

                        //var data = JSON.parse(response.data);
                        var data = response.data.status;
                        if (data) {
                            $scope.isError = false;
                            $scope.isSuccess = true;
                            $scope.message = GetMessage.dataUploadedSuccessfully;
                        }
                        else {
                            $scope.message = GetMessage.UploadFileIntoElasticSearchFailed;
                            $scope.isError = true;
                            $scope.isSuccess = false;
                        }

                        //$timeout(hideMessage, 10000);
                        $('#upload').modal('toggle');
                        $('.border-red').removeClass('border-red');
                        $scope.getData();
                        progressBarService.hideProgressBar();
                    }
                });
            }
        };

        $scope.update = function () {
            if ($scope.ValidateUploadDataManagement()) {
                progressBarService.showProgressBar();

                data = {
                    eSpectraObjectID: $scope.eSpectraObjectID,
                    eSpectraObjectDataSetName: $scope.eSpectraObjectDataSetName,
                    eSpectraSpecimenHostMaterial: $scope.dataManagement.HostMaterial,
                    eSpectraSpecimenChemicalName: $scope.dataManagement.ChemicalName,
                    ReferencedArticle: $scope.dataManagement.ReferencedArticle,
                    eSpectraObjectTechnique: $scope.dataManagement.Techinque,
                    eSpectraObjectDesc: $scope.dataManagement.Description,
                    FirstName: $scope.dataManagement.FirstName,
                    LastName: $scope.dataManagement.LastName,
                    //eSpectraLastUpdateUserID: $cookies.get("UserId"),
                    eSpectraObjectDOI: $scope.dataManagement.ReferencedArticle,
                    eSpectraObjectCalibration: $scope.dataManagement.eSpectraObjectCalibration,
                    eSpectraObjectShareType: $scope.dataManagement.FileShare,
                    eSpectraCasRegistryNum: $scope.dataManagement.CasRegistryNumber
                }

                dataManagementService.updateDatamanagement(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.modalMessage = response.data.message;
                        $scope.isModalError = true;
                        $scope.isModalSuccess = false;
                        progressBarService.hideProgressBar();
                        //$timeout(hideMessage, 10000);
                    }
                    else {

                        //var data = JSON.parse(response.data);
                        if (response.data) {
                            $scope.isError = false;
                            $scope.isSuccess = true;
                            $scope.message = GetMessage.dataUpdatedSuccessfully;
                        }
                        else {
                            $scope.message = GetMessage.UploadFileIntoElasticSearchFailed;
                            $scope.isError = true;
                            $scope.isSuccess = false;
                        }

                        //$timeout(hideMessage, 10000);
                        $('#upload').modal('toggle');
                        $('.border-red').removeClass('border-red');
                        $scope.getData();

                    }
                    progressBarService.hideProgressBar();
                });
            }
        };

        $scope.deleteValidate = function (data) {
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = '';
            $("#confirmDelete").modal('toggle');
            $("#data-del-no-btn").focus();

            $scope.objects = [];
            $scope.fileNames = [];

            $scope.objects.push(data.eSpectraObjectID);
            $scope.fileNames.push(data.eSpectraObjectDataSetName);
        }

        $scope.compareValidate = function () {
            var checkedCheckboxes;
            if ($scope.activeTab == 1) {
                checkedCheckboxes = $('.chk:checked');
            } else
                if ($scope.activeTab == 2) {
                    checkedCheckboxes = $('.chkTeam:checked');
                }
            var compareDataList = [];
            $rootScope.compareStoreData = [];
            if (checkedCheckboxes.length <= 0) {
                $scope.isError = true;
                $scope.isSuccess = false;
                //$timeout(hideMessage, 10000);
                $scope.message = GetMessage.selectRecordsToCompare;
                return false;
            } else {
                $.each(checkedCheckboxes, function (index, value) {
                    var compareDataArray = {
                        eSpectraObjectID: $(this).val(),
                        eSpectraObjectDataSetName: $(this).attr('fileName')
                    }
                    compareDataList.push(compareDataArray);
                });
                if (compareDataList.length > 0) {
                    $rootScope.compareStoreData = compareDataList;
                    $location.path('/plotgraph');
                }
            }
        }

        $scope.deleteData = function () {
            $("#confirmDelete").modal('toggle');
            progressBarService.showProgressBar();

            dataManagementService.deleteFile($scope.objects.join(), $scope.fileNames.join()).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                    //$timeout(hideMessage, 10000);
                }
                else {
                    if (response.data) {
                        $scope.isError = false;
                        $scope.isSuccess = true;
                        $scope.message = GetMessage.dataDeletedSuccessfully;
                    }
                    else {
                        $scope.message = GetMessage.UploadFileIntoElasticSearchFailed;
                        $scope.isError = true;
                        $scope.isSuccess = false;
                    }
                    //$timeout(hideMessage, 10000);
                    $scope.getData();
                }
            });
            $scope.objects = [];
            $scope.fileNames = [];
            progressBarService.hideProgressBar();
        };

        $scope.checkAll = function (event) {

            var isChecked = $(event.currentTarget)[0].checked;


            if (isChecked) {
                $('.chk').prop('checked', 'checked');
            } else {
                $('.chk').prop('checked', '');
            }

            var checkedCheckboxes = $('.chk:checked').length;

            if (checkedCheckboxes > 0) {
                $scope.checkBoxChecked = true;
            } else {
                $scope.checkBoxChecked = false;
            }
        }

        $scope.checkTeamAll = function (event) {
            //if ($scope.dataManagementDetails.teamManagementFiles[0].isAdminSubscribed == 1) {
                var isChecked = $(event.currentTarget)[0].checked;


                if (isChecked) {
                    $('.chkTeam').prop('checked', 'checked');
                } else {
                    $('.chkTeam').prop('checked', '');
                }

                var checkedCheckboxes = $('.chkTeam:checked').length;

                if (checkedCheckboxes > 0) {
                    $scope.checkBoxChecked = true;
                } else {
                    $scope.checkBoxChecked = false;
                }
            //}
        }

        $scope.checkFile = function () {
            var totalLength = $('.chk').length;
            var checkedCheckboxes = $('.chk:checked').length;
            if (checkedCheckboxes == totalLength) {
                $('#chkAll').prop('checked', 'checked');

            } else {
                $('#chkAll').prop('checked', '');

            }

            if (checkedCheckboxes > 0) {
                $scope.checkBoxChecked = true;
            } else {
                $scope.checkBoxChecked = false;
            }
        }

        $scope.checkTeamFile = function () {
            //if ($scope.dataManagementDetails.teamManagementFiles[0].isAdminSubscribed == 1) {
                var totalLength = $('.chkTeam').length;
                var checkedCheckboxes = $('.chkTeam:checked').length;
                if (checkedCheckboxes == totalLength) {
                    $('#chkTeamAll').prop('checked', 'checked');

                } else {
                    $('#chkTeamAll').prop('checked', '');

                }

                if (checkedCheckboxes > 0) {
                    $scope.checkBoxChecked = true;
                } else {
                    $scope.checkBoxChecked = false;
                }
            //}
        }

    }]);

    app.service('storeUploadService', [function () {
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }

        this.validateReferenceArticle = function (_this, $scope) {
            var arr = _this.val().split('/');
            if (_this.val() != '') {
                if (arr.length > 1) {
                    if (arr[arr.length - 1] == "") {
                        $scope.dataManagementUpload.referencedArticle.$invalid = true;
                        $scope.validDOI = false;
                    } else {
                        var countLength = 0;
                        for (var i = 0; i < arr.length; i++) {
                            if (isFloat(parseFloat(arr[i]))) {
                                countLength++;
                            }
                        }
                        if (countLength == arr.length) {
                            $scope.dataManagementUpload.referencedArticle.$valid = true;
                            $scope.validDOI = true;
                        } else {
                            $scope.dataManagementUpload.referencedArticle.$invalid = true;
                            $scope.validDOI = false;
                        }
                    }
                } else {
                    if (isFloat(parseFloat(arr[0]))) {
                        $scope.dataManagementUpload.referencedArticle.$valid = true;
                        $scope.validDOI = true;
                    } else {
                        $scope.dataManagementUpload.referencedArticle.$invalid = true;
                        $scope.validDOI = false;
                    }
                }
            } else {
                $scope.dataManagementUpload.referencedArticle.$valid = true;
                $scope.validDOI = true;
            }
            $scope.$apply();
        }

        this.onFileShareSelected = function (value, $scope) {
            var flag = false;
            for (var key in $scope.FileShare) {
                if ($scope.FileShare[key]) {
                    flag = true;
                }
            }
            if (value == 'Y' && $scope.FileShare.Yes == true && $scope.FileShare.No == true) {
                $scope.FileShare.No = false;
            } else if (value == 'N' && $scope.FileShare.Yes == true && $scope.FileShare.No == true) {
                $scope.FileShare.Yes = false;
            }
            if (!flag) {
                $scope.FileShare = undefined;
            }
        };
    }]);

})();